<template>
    <div>
        <!-- 表格 -->
        <el-table :data="vo.tableList" style="width: 100%; margin-top: 16px" v-loading="vo.loading">
            <el-table-column prop="company_name" label="公司名" width="240"> </el-table-column>
            <el-table-column prop="realname" label="姓名" width="70"> </el-table-column>
            <el-table-column prop="phone" label="手机号" width="140"> </el-table-column>
            <el-table-column prop="" label="合作类型" width="240">
                <template #default="{ row }">{{ getTypes(row.cor_types) }}</template>
            </el-table-column>
            <el-table-column prop="comments" label="Comments"> </el-table-column>
            <el-table-column prop="" label="状态" width="70">
                <template #default="{ row }">
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        :content="row.reason"
                        :disabled="row.status !== 2"
                        placement="left"
                    >
                        <el-tag :type="row.status === 0 ? 'info' : row.status === 1 ? 'success' : 'danger'">
                            {{ getStatusLabel(row.status) }}
                        </el-tag>
                    </el-tooltip>
                </template></el-table-column
            >
            <el-table-column prop="created" label="创建时间" width="170"> </el-table-column>
            <el-table-column label="操作" class-name="deal-column" width="230">
                <template #default="{ row }">
                    <el-button text type="primary" v-if="row.status === 0" @click="handleStatus(row, 1)">
                        审核通过
                    </el-button>
                    <el-button text type="primary" v-if="row.status === 0" @click="handleStatus(row, 2)">
                        拒绝
                    </el-button>
                    <el-button text type="primary" @click="deleteClick(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-style">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="vo.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
    </div>
</template>
<script setup>
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '@/request/index';
import { reactive, ref } from 'vue';
import { requestDomain } from '../../../package.json';
const po = reactive({
    targetInfo: {
        productId: '',
        name: ''
    },
    pageObj: {
        page: 1,
        perPage: 10
    },
    types: {
        other: '其他合作',
        nets: '入驻销售网络',
        selection: '入驻选型手册',
        indexAd: '首页广告'
    }
});
const getStatusLabel = status => {
    return status === 0 ? '未审核' : status === 1 ? '已通过' : '已拒绝';
};
const getTypes = types => {
    let typeLabels = [];
    const tempTypes = types.split(',');
    tempTypes.forEach(item => {
        typeLabels.push(po.types[item]);
    });
    return typeLabels.join(',');
};
const vo = reactive({ tableList: [], loading: true, total: 0 });

// 根据应用查询角色级联信息
const queryInitHandler = async function () {
    vo.loading = true;
    const queryParams = { ...po.pageObj };
    const result = await request('queryCorperateLists', queryParams);
    const list = result.data.list;
    if (result.data.totalCount === 0) {
        vo.tableList = [];
    } else {
        vo.tableList = list;
    }
    vo.total = result.data.totalCount;
    vo.loading = false;
};

const handleSizeChange = function (e) {
    po.pageObj.pageSize = e;
    po.pageObj.page = 1;
    queryInitHandler();
};
const handleCurrentChange = function (e) {
    po.pageObj.page = e;
    queryInitHandler();
};

const handleStatus = (row, status) => {
    if (status === 2) {
        ElMessageBox.prompt('拒绝理由', '提示', {
            confirmButtonText: '提交',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '请输入拒绝理由'
        }).then(async ({ value }) => {
            if (!value) {
                ElMessage({
                    type: 'error',
                    message: `请输入拒绝理由`
                });
                return;
            }
            const result = await request('updateCorperate', {
                id: row.id,
                reason: value,
                status: 2
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        });
    } else {
        ElMessageBox.confirm('确认执行此操作吗', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                const result = await request('updateCorperate', {
                    id: row.id,
                    status: 1
                });
                if (result.status === 200) {
                    ElMessage({
                        message: result.msg,
                        type: 'success'
                    });
                    queryInitHandler();
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    }
};
const deleteClick = row => {
    ElMessageBox.confirm('确认要删除此数据吗', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const result = await request('deleteCorperate', {
                id: row.id
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        })
        .catch(() => {
            console.log('cancel');
        });
};
queryInitHandler();
</script>
